import o, { useContext as t } from "react";
import { PrimaryNavContext as r } from "./PrimaryNavContext";

var c = function c() {
  var _t = t(r),
      e = _t.setIsDesktopMenuOpen,
      n = _t.setActiveFlyout;

  return o.createElement("div", {
    className: "hg-primarynav__blur",
    onClick: function onClick() {
      e(!1), n(null);
    },
    role: "none"
  });
};

export { c as NavBlurBackground };